'use es6';

import { createSelector } from 'reselect';
import { getLesson } from './lessonSelectors';
import { getTrack } from './trackSelectors';
export const getRecommendationsMap = state => state.recommendations;
export const getRecommendationsMetadataList = (state, recommendations) => recommendations.map(recommendation => {
  const metadata = recommendation.recommendationMetadata;
  if (metadata.entityType === 'LESSON') {
    const lesson = getLesson(state, {
      lessonId: metadata.entityId
    });
    return Object.assign({}, metadata, {
      entityCategory: 'CONTENT',
      contentName: lesson && lesson.get('name'),
      href: `/academy/${state.auth.portal.portal_id}/lessons/${metadata.entityId}`
    });
  }
  if (metadata.entityType === 'TRACK') {
    const track = getTrack(state, {
      trackId: metadata.entityId
    });
    return Object.assign({}, metadata, {
      entityCategory: 'CONTENT',
      contentName: track && track.get('name'),
      href: `/academy/${state.auth.portal.portal_id}/tracks/${metadata.entityId}`
    });
  }
  return metadata;
});
const getRecommendationsTopicPreferencesMap = createSelector(getRecommendationsMap, map => map.get('topicPreferences'));
export const getRecommendationsTopicPreference = createSelector(getRecommendationsTopicPreferencesMap, map => map.get('data'));